<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-account-settings" inline title="Roles">
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />
          <router-link :to="{ name: 'SystemSaveRoles' }">
            <v-btn elevation="1" color="accent">
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </router-link>
        </v-card-text>
        <v-divider class=" my-0 " />
        <v-data-table
          v-if="roles.length"
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          :items-per-page="10"
          :headers="headers"
          :items="roles"
          :search="search"
        >
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
          <template v-slot:item.actions="{ item }">
            <router-link :to="{ name: 'DynamicLevelListing', params: { roleId: item.id } }">
              <v-btn class="px-2 ml-1 ma-1" color="warning" min-width="0" small>
                <v-icon small>mdi-format-list-bulleted-square</v-icon>
              </v-btn>
            </router-link>
            <router-link :to="{ name: 'SystemEditRoles', params: { roleId: item.id } }">
              <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </router-link>
            <v-btn @click="deleteRole(item.id)" class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="!item.deletedAt">
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <v-btn class="px-2 ml-1 ma-1" min-width="0" small color="info" @click="restoreRole(item.id)" v-if="item.deletedAt"> Reset </v-btn>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="text-right">
              <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small>
                <v-icon small> mdi-delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  name: 'AdminRoles',
  components: { MaterialCard },
  data () {
    return {
      page: 1,
      noOfPages: 1,
      isLoading: false,
      enablePagination: true,
      roles: [],
      loadingComponent: null,
      dialog: false,
      dialogDelete: false,
      search: '',
      headers: [
        { text: 'Name', sortable: true, value: 'role' },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Created At', value: 'createdAt', sortable: true },
        { text: 'Updated At', value: 'updatedAt', sortable: true },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
        // { text: 'More actions', value: 'data-table-expand', align: 'center', sortable: false }
      ]
    }
  },

  created () {
    this.getRoles()
  },
  methods: {
    getRoles: function () {
      this.isLoading = true

      http
        .get(`${CONSTANTS.API_URL}/api/roles`, {
          page: this.page
        })
        .then(reaponse => {
          this.isLoading = false

          let roles = reaponse.data
          this.roles = roles
          this.roles.map(obj => {
            obj.createdAt = new Date(obj.createdAt).toLocaleString()
            obj.updatedAt = new Date(obj.updatedAt).toLocaleString()
          })
          this.noOfPages = roles.length % 100 > 0 ? Math.trunc(roles.length / 100) + 1 : roles.length / 100
          this.enablePagination = this.noOfPages > 1
        })
        .catch(httpException => {
          console.warn('Error while deleting Role', httpException.message)
          this.isLoading = false

          return this.$dialog.error({
            title: 'Error',
            text: 'Error while Deleting Role'
          })
        })
    },
    deleteRole: function (roleId) {
      let that = this
      console.log('trigged')
      this.$dialog.warning({
        title: 'Deactivate Role?',
        text: 'Are you sure you want to deactivate this Role?',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              return false
            }
          },
          true: {
            color: 'success',
            text: 'Yes',

            handle: async () => {
              try {
                this.isLoading = true
                return http.delete(`${CONSTANTS.API_URL}/api/role/${roleId}`).then(() => {
                  that.getRoles()
                  this.isLoading = false
                  return this.$dialog.info({
                    title: 'Success',
                    text: 'Role Deactivated successfully.'
                  })
                })
              } catch (httpException) {
                console.warn('Error while deleting Role', httpException.message)
                this.isLoading = false

                return this.$dialog.error({
                  title: 'Error',
                  text: 'Error while Deleting Role'
                })
              } finally {
                this.isLoading = false
              }
            }
          } }
      })
    },
    restoreRole: function (roleId) {
      this.$dialog.info({
        title: 'Restore Role?',
        text: 'Are you sure you want to <b>restore</b> this Role?',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              return false
            }
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: () => {
              this.isLoading = true
              return http
                .put(`${CONSTANTS.API_URL}/api/role/${roleId}/restore`)
                .then(() => {
                  this.getRoles()
                  this.isLoading = false

                  return this.$dialog.info({
                    title: 'Success',
                    text: 'Role restored successfully.'
                  })
                })
                .catch(httpException => {
                  this.isLoading = false
                  console.warn('Error while restoring Role', httpException.message)
                  return this.$dialog.error({
                    title: 'Error',
                    text: httpException.message
                  })
                })
            }
          } }
      })
    },
    loadPrev: function () {
      this.page--
      this.getRoles()
    },
    loadMore: function () {
      this.page++
      this.getRoles()
    }
  }
}
</script>
